<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    title="更新策略"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 文案 -->
      <a-form-item
        label="策略名称"
        name="name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.name"
        />
      </a-form-item>
      <!-- 目标平台 -->
      <a-form-item
        label="目标平台"
        name="platform"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          mode="multiple"
          v-model:value="formState.platform"
          placeholder="请选择"
        >
          <a-select-option value="ios">iOS</a-select-option>
          <a-select-option value="android">Android</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 目标版本 -->
      <a-form-item
        label="目标版本"
        name="version"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          placeholder="请输入"
          v-model:value="formState.version"
        />
      </a-form-item>
      <!-- 是否强制 -->
      <a-form-item
        label="是否强制"
        name="status"
        :rules="[{ required: true }]"
      >
        <a-radio-group
          v-model:value="formState.status"
        >
          <a-radio :value="0">否</a-radio>
          <a-radio :value="1">是</a-radio>
        </a-radio-group>
      </a-form-item>
    <template v-for="(item, index) in formState.content" :key="index">
      <a-form-item
        :label="item.name"
        :name="['content', index, 'content']"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-textarea
          v-model:value="item.content"
          placeholder="请输入"
          :auto-size="{ minRows: 3, maxRows: 6 }"
        />
      </a-form-item>
    </template>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import { langSearchList } from '@/api/admin'
import { versionSave } from '@/api/admin'

// emit
const emit = defineEmits(['success'])
// Form实例
const RefForm = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// id
let id = ref(undefined)
// 详情
let detail = ref({})
// 剧集信息
let formState = reactive({
  // 策略名称
  name: undefined,
  // 目标平台
  platform: [],
  // 目标版本
  version: undefined,
  // 是否强制
  status: 0,
  // 内容
  content: []
})


// 打开抽屉
function showDrawer (params) {
  // 展开
  visible.value = true
  // id
  id.value = params.id
  // 详情
  detail.value = params
  // 获取选择项列表
  getSelectList()
  // 复选详情内容
  nextTick(() => {
    if (id.value) {
      formState.name = detail.value.name
      formState.platform = detail.value.platform
      formState.version = detail.value.version
      formState.status = detail.value.status
      // formState.content = detail.value.lang_version.map(item => ({
      //   id: item.id,
      //   name: item.name,
      //   content: item.content
      // }))
    }
  })
}

// 获取选择项列表
function getSelectList () {
  const params = {
    page: 1,
    page_size: 10000
  }
  langSearchList(params).then(res => {
    const { code, data } = res
    if (code === 0) {
      let content = []
      data.forEach(item => {
        content.push({
          id: item.id,
          name: item.name,
          content: undefined
        })
      })
      if (id.value) {
        content.forEach(item => {
          const matched = (detail.value.lang_version || []).find(d => d.id === item.id) || {}
          item.content = matched.content
        })
      }
      formState.content = content
      console.log(formState.content);
    }
  })
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    // 表单重置
    RefForm.value.resetFields()
    formState.content = []
    formState.name = undefined
    formState.platform = []
    formState.version = undefined
    formState.status = 0
    visible.value = false
  }
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    const params = {
      id: id.value,
      name: formState.name,
      status: formState.status,
      platform: formState.platform,
      version: formState.version,
      content: formState.content
    }
    versionSave(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        // 更新父组件
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.a-link {
  margin-left: 8px;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  position: relative;
  // width: 118px;
  // height: 148px;
  width: 208px;
  height: 124px;
  border-radius: 4px;
  overflow: hidden;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
.upload-item-select {
  position: absolute;
  right: 8px;
  bottom: 8px;
}
.upload-item-delete {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 18px;
  color: #8D8D8D;
  cursor: pointer;
  opacity: 0;
}
.form-upload-item:hover .upload-item-delete {
  opacity: 1;
}
.date-range {
  color: #8D8D8D;
  padding-left: 100px;
  margin-top: -15px;
}
</style>